import { RouteLocation } from 'vue-router';
import { Users } from 'src/api';
import { RouteCustomMeta } from 'src/router/routes';

export const Groups = {
  Managers: 'managers',
  Developers: 'developers',
};
// export const DefaultGroups = [Groups.Managers];

// Using look up tables
// const PERMISSIONS = {
//   admin: ['write', 'edit', 'read', 'delete'],
//   moderator: ['write', 'edit', 'read'],
//   anybody: ['read'],
// };
//
// const getPermissionsFor = (role: keyof PERMISSIONS) => PERMISSIONS[role] || [];
//
// const hasPermissions = (role: string, resource: string) =>
//   getPermissionsFor(role).includes(resource);

export function hasAccess(user: Users.Types.User, route: RouteLocation) {
  if (route.path.startsWith('/auth')) {
    return true;
  }

  if (user) {
    const allowedGroups =
      (route.meta as unknown as RouteCustomMeta)?.auth?.groups || [];

    // allow by default
    if (!allowedGroups || !allowedGroups.length) {
      return true;
    }

    // console.log({ userGroups: user.groups });

    // restrict for not specified (if specified) groups
    return user.groups.some((group) => allowedGroups.includes(group));
  }

  return false;
}
